import type { WorkInProgressAgent } from '../types/work-in-progress';

/** WIP 列表前台轮询间隔。 */
export const WORK_IN_PROGRESS_REFRESH_INTERVAL = 10_000;

/** WIP 展开状态的浏览器持久化键。 */
export const WORK_IN_PROGRESS_EXPANDED_STORAGE_KEY = 'eureka-ip:home-v2:work-in-progress:expanded';

/** Design FTO 报告导出状态轮询间隔。 */
export const DESIGN_FTO_EXPORT_POLL_INTERVAL = 2_000;

/** Design FTO 报告导出状态最大轮询次数。 */
export const DESIGN_FTO_EXPORT_MAX_ATTEMPTS = 450;

/** FTO 报告生成状态轮询间隔，与 FTO 报告页保持一致。 */
export const FTO_REPORT_GENERATION_POLL_INTERVAL = 5_000;

/** FTO 报告生成状态最大轮询次数。 */
export const FTO_REPORT_GENERATION_MAX_ATTEMPTS = 120;

/** WIP Agent 类型对应的本地化文案键。 */
export const WORK_IN_PROGRESS_AGENT_I18N_KEYS: Partial<Record<WorkInProgressAgent, string>> = {
    NOVELTY_SEARCH: 'workInProgress.agent.noveltySearch',
    FTO_SEARCH: 'workInProgress.agent.ftoSearch',
    DESIGN_FTO_SEARCH: 'workInProgress.agent.designFtoSearch',
};
